<template>
  <div class="home">
     <b-row no-gutters>
      <b-col cols="12" md="6"><Map :allMarkers="c_mapData" :p_highlightMarker="d_highlightMarker" @highlightAddress="m_highlightAddress"/></b-col>
      <b-col
        cols="12"
        md="6"
        class="border p-2 d-block d-sm-none d-md-block opportunityCards-desktop"
      >
         <div>
			<Card v-if="d_header_opportunity" class="headerOpportunity" :p_opportunity="d_header_opportunity" @highlightMarker="m_highlightMarker" />
		</div>
        <div
          v-for="opportunity in d_opportunityCards"
          :key="opportunity.opportunityId"
        >
          <Card  :p_opportunity="opportunity" @highlightMarker="m_highlightMarker"/>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import Card from "./KT-MapCard.vue";
import Map from "./KT-Map.vue";
import "vue-search-select/dist/VueSearchSelect.css";
import {refData} from "@/utils/ref-data.js";

export default {
  name: "Home",
  components: {
    //Navba,
    Map,
    Card
  },
  created(){
  
  
  },
  mounted() {
	this.m_createMapData();	
  },
  props: {
    p_mapData: Array,
	p_refData: Object,
  },
  data() {
    return {
 
		d_mapData:[],
      d_header_opportunity:{},
      d_highlightMarker:null,
      d_opportunityCards: [],
    };
  },
  methods: {
	m_createMapData(){
		this.d_mapData=[...this.p_mapData];
		
		console.log('p_mapData');
		console.log(this.p_mapData);
	
		//add statusName,marketSegmentName,clientName to cards.
		this.d_mapData.forEach(m=>{
		var status=refData.opportunityStatuses.find(s=>s.id==m.opportunityStatusId);
		if(status) m["statusName"]=status.name;
		var marketSegment=refData.marketSegments.find(s=>s.id==m.marketSegmentId);
		if (marketSegment) m["marketSegmentName"]=marketSegment.name;
		var account=this.p_refData.accountId.find(a=>a.accountId==m.clientAccountId);
		if(account) m["clientName"]=account.accountName;
	});

		this.d_header_opportunity=this.d_mapData[0];
		//this.d_mapData.splice(0, 1);
		this.d_opportunityCards=[ ...this.d_mapData];
		this.d_opportunityCards.splice(0, 1);
		
		
		console.log('d_opportunityCards');
		console.log(this.d_opportunityCards);
		
		console.log('d_header_opportunity');
		console.log(this.d_header_opportunity);

		//highlight the marker of header address.
		//this.d_highlightMarker=this.d_header_opportunity.opportunityNo;
		

	
		},
		m_highlightAddress(opportunityNo){
			if(opportunityNo != this.d_header_opportunity?.opportunityNo){
				this.d_opportunityCards.unshift(this.d_header_opportunity);
				this.d_header_opportunity= this.d_opportunityCards.find(c => c.opportunityNo == opportunityNo);
				const cardId = this.d_opportunityCards.findIndex(c => c.opportunityNo == opportunityNo);
				this.d_opportunityCards.splice(cardId, 1);
			}
		},
		m_highlightMarker(opportunityNo){
        this.d_highlightMarker=opportunityNo; 
        console.log('In m_highlightMarker:'+opportunityNo);
        }
 
  },
  computed: {
	c_mapData(){
		console.log("In c_mapData");
		console.log(this.d_mapData);
		return this.d_mapData;
	}
  },
  watch: {
	p_mapData(){
	this.m_createMapData();
	}
  }
};
</script>
<style scoped>
.home {
  padding: 0 3%;
}
.research {
  padding-left: 20px;
  padding-right: 20px;
  border-radius: 50px;
  border: none;
  background-color: rgb(234, 234, 234);
}
.research::placeholder {
  font-size: 10px;
}
.fa-search {
  right: 10px;
  top: 10px;
}
.tag_btn,
.tag_btn:hover,
.tag_btn:active,
.tag_btn:focus {
  color: #2b91ff !important;
  font-weight: bold;
  background-color: transparent !important;
  box-shadow: none !important;
}
.due-date {
  margin-top: 35px !important;
  font-size: 16px !important;
  font-weight: 400 !important;
  margin-bottom: 2px !important;
}
.count {
  background-color: red;
  color: white;
  border-radius: 50px;
  left: 0;
  top: 0;
  width: 20px;
  height: 20px;
  line-height: 1.3;
}
.select-options-form-top {
  width: 125px;
  margin: 10px;
}
.navbar-opportunities {
  width: 100%;
}
.mobile-content-opportunityCards {
  /* width: 300px; */
  height: 40px;
}
.mobile-content-filters {
  /* width: 300px; */
  height: 40px;
}
.content-opportunityCards {
  z-index: 999;
  left: 20%;
  background: white;
  max-height: 800px;
  max-width: 550px;
  overflow: auto;
}
.content-filters {
  z-index: 999;
  background: white;
  max-height: 800px;
  /* max-width: 63vw; */
  max-width: 74vw;
  /* overflow: auto; */
  position: absolute;
  /* left: 33%; */
  left: 21.7%;
  /* min-width: 700px; */
}
.toggler {
  padding: 0.25rem 0.75rem;
  font-size: 2.25rem;
  line-height: 1;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}
.toggler-row {
  justify-content: flex-end;
}
.search-form {
  display: flex;
}
.opportunityCards-desktop {
  max-height: 700px;
  overflow: auto;
}
.range-slider {
  /* width: 300px; */
  margin: 10px;
  /* text-align: center;
  position: relative;
  height: 6em; */
  display: flex;
  align-items: center;
}

.range-slider input[type="range"] {
  position: absolute;
  left: 0;
  bottom: 0;
}

input[type="number"] {
  border: 1px solid #ddd;
  text-align: center;
  -moz-appearance: textfield;
}

input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type="number"]:invalid,
input[type="number"]:out-of-range {
  border: 2px solid #ff6347;
}

input[type="range"] {
  -webkit-appearance: none;
  width: 100%;
}

input[type="range"]:focus {
  outline: none;
}

input[type="range"]:focus::-webkit-slider-runnable-track {
  background: #2497e3;
}

input[type="range"]:focus::-ms-fill-lower {
  background: #2497e3;
}

input[type="range"]:focus::-ms-fill-upper {
  background: #2497e3;
}

input[type="range"]::-webkit-slider-runnable-track {
  width: 100%;
  height: 5px;
  cursor: pointer;
  animate: 0.2s;
  background: #2497e3;
  border-radius: 1px;
  box-shadow: none;
  border: 0;
}

input[type="range"]::-webkit-slider-thumb {
  z-index: 2;
  position: relative;
  box-shadow: 0px 0px 0px #000;
  border: 1px solid #2497e3;
  height: 18px;
  width: 18px;
  border-radius: 25px;
  background: #a1d0ff;
  cursor: pointer;
  -webkit-appearance: none;
  margin-top: -7px;
}
.filter-options {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-content: space-around;
}
.filter-options-top {
  margin-top: 30px;
}
.filter-buttons {
  width: 110px;
  margin-top: 65px;
}

.ui.selection.dropdown {
  width: 125px !important;
  width: 100% !important;
  height: 38px !important;
  /* margin: 8px 10px 10 10px !important; */
  white-space: nowrap !important;

  /* overflow-x: clip !important; */

  /* text-overflow: ellipsis !important; */
}

.ui.search.dropdown > input.search {
  margin: 10px !important;
}
.filter-options-buttons {
  color: blue;
}
.filter-options-buttons:hover {
  cursor: pointer;
}
/* .mobile-content-filters .select-options-form[data-v-fae5bece] {
  width: 100% !important;
} */
.mobile-content-filters label {
  white-space: nowrap !important;
}

.label-sm {
  font-size: 12px !important;
}
.date-col label {
  margin-bottom: 0px !important;
  /* margin-left: 10px !important; */
}
.headerOpportunity {
  border:2px solid green;
}
</style>
